import Profile from '../../components/Profile';

export default function StudentProfile() {
  return <Profile role="student" />;
}